import { useInvalidatePortfolios } from '@/entities/portfolio';
import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export const useDeletePortfolio = () => {
  const mutation = trpc.portfolioManagement.items.delete.useMutation();
  const action = useAsyncAction(mutation.mutateAsync, useInvalidatePortfolios());
  return { ...action, deletePortfolio: action.execute };
};
